module.exports = __webpack_public_path__ + "img/s-3.6eb2723e.svg";